<template>
  <el-container>
    <el-header>
      <Header title="鹿客竞练管理后台"></Header>
    </el-header>
    <div class="slide-img">
      <div class="competition-info">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/contest' }">赛事首页</el-breadcrumb-item>
          <el-breadcrumb-item>当前比赛</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="competition-desc" v-if="start_time">
          <h1>{{title}} (第{{times}}次重现赛)</h1>
          <p>{{start_time | timestampToTime}} 至 {{end_time | timestampToTime}}</p>
          <p>时长：{{time_length | testTime}}</p>
          <p>已有{{studentNum}}人报名</p>
        </div>
        <div class="competition-setting">
          <i class="el-icon-setting" @click="editCompetition" v-if="user_role===2"></i>
        </div>
      </div>
    </div>
    <el-main v-if="title">
      <div class="applied">
        <el-menu :default-active="$route.path" mode="horizontal" :router="true">
          <el-menu-item :index="`/contest/replay/`+competition_id+`/`+times+`/introduce`" :class="$route.name==='replay-introduce'?'is-active':''">比赛说明</el-menu-item>
          <el-menu-item :index="`/contest/replay/`+competition_id+`/`+times+`/index`" :class="$route.name==='replay-index'?'is-active':''">比赛内容</el-menu-item>
          <el-menu-item :index="`/contest/replay/`+competition_id+`/`+times+`/rank-list`" :class="$route.name==='replay-rank-list'?'is-active':''">排名</el-menu-item>
        </el-menu>
        <div class="down-time" v-if="isLogin">
          <div class="replay-btn" v-if="is_start===2">
            <el-button size="small" @click="viewHistory">查看历史记录</el-button>
            <el-button type="primary" size="small" @click="createReplay">创建重现赛</el-button>
          </div>
          <span v-if="is_start!=2">
            距离比赛结束还有:
            <i class="time-tag">{{competition_end.days}}</i>天
            <i class="time-tag">{{competition_end.hours}}</i>时
            <i class="time-tag">{{competition_end.minutes}}</i>分
            <i class="time-tag">{{competition_end.seconds}}</i>秒
          </span>
        </div>
      </div>
      <div style="margin:20px 0;">
        <router-view :competitionObj="competitionObj" :hide="1" :replay_type="replay_type" :test_status="is_start" :times="times" @changeStatus="changeTestStatus"></router-view>
      </div>
    </el-main>
    <el-dialog title="历史记录" :visible.sync="dialogTableVisible" width="600px">
      <History :competition_id="competition_id" :classroom_id="0" />
    </el-dialog>
  </el-container>
</template>
<script>
import { getToken } from "@/utils/auth";
import Header from "@/layouts/app/Header";
import Introduce from "@/views/show/competition-desc";
import Content from "@/views/show/index";
import RankList from "@/views/show/rank-list";
import EntryForm from "@/components/EntryForm";
import ApplyForm from "@/components/ApplyForm";
import History from "@/components/HistoryData";
import { selectReplayData, createReplay } from "@/api/contest";
import Common from "@/utils/common";
import { setInterval } from "timers";
import { parse } from "path";
export default {
  name: "replay",
  components: {
    Header,
    Introduce,
    Content,
    RankList,
    EntryForm,
    ApplyForm,
    History
  },
  created() {
    this.isLogin = getToken() ? true : false;
  },
  watch: {
    end_time: function () {
      let currentTime = Date.parse(new Date()) / 1000;
      if (this.end_time > currentTime) {
        this.countDown(this.end_time, 1);
      }
    }
  },
  data() {
    return {
      competition_id: "", //竞赛id
      title: "", //竞赛标题
      time_length: "", //考试时长
      studentNum: "", //报名人数
      competitionObj: {
        summary: "", //比赛说明
        materials: [] //附件
      },
      user_role: 0, //用户角色，0为考生，1为评委，2为创建者
      is_start: 0, //比赛状态，0为未开始，1为已开始，2为已结束
      activeIndex: "0",
      start_time: "", //比赛开始时间
      end_time: "", //比赛结束时间
      apply_time: "", //报名时长
      timer: "", //定时器
      competition_end: {
        //比赛结束倒计时
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      isLogin: false,
      replay_type: 1, //是否参与重现赛
      times: 0, //第几次参与重现赛
      dialogTableVisible: false,
    };
  },
  mounted() {
    this.competition_id = this.$route.params.competitionId;
    this.times = this.$route.params.times;
    this.initData();
  },
  methods: {
    initData: function () {
      let params = {
        competition_id: this.competition_id,
        replay_type: this.replay_type,
        times: this.times,
        classroom_id: 0
      };
      selectReplayData(params).then(response => {
        this.title = response.data.title;
        this.start_time = response.data.testStartTime;
        this.end_time = response.data.testExpiryTime;
        this.studentNum = response.data.studentNum;
        this.competitionObj.summary = response.data.summary;
        this.competitionObj.materials = response.data.materials;
        this.user_role = response.data.user_role;
        this.is_start = response.data.test_status;
        this.time_length = response.data.time_length;
      });
    },
    //判断当前重现赛状态，是否已经结束或者提交
    jugeStatus: function () {
      let status = "";
      if (this.is_start) {
        //比赛开始并且已报名
        status = 1;
      } else {
        //比赛开始但是报名正在审核或被拒绝或者没报名
        status = 0;
      }
      return status;
    },
    //倒计时
    countDown: function (timestamp, type) {
      let self = this;
      let timer = "timer" + type;
      timer = setInterval(function () {
        let nowTime = new Date();
        let endTime = new Date(timestamp * 1000);
        let t = endTime.getTime() - nowTime.getTime();
        if (t > 0) {
          let day = Math.floor(t / 86400000);
          let hour = Math.floor((t / 3600000) % 24);
          let min = Math.floor((t / 60000) % 60);
          let sec = Math.floor((t / 1000) % 60);
          hour = hour < 10 ? "0" + hour : hour;
          min = min < 10 ? "0" + min : min;
          sec = sec < 10 ? "0" + sec : sec;
          if (type) {
            self.competition_end = {
              days: day,
              hours: hour,
              minutes: min,
              seconds: sec
            };
          }
        } else {
          if (type) {
            self.is_start = 2;
          }
          clearInterval(timer);
        }
      }, 1000);
    },
    //编辑竞赛
    editCompetition: function () {
      this.$router.push({
        name: "contest-base",
        params: { competitionId: this.competition_id },
        query: { from: this.$route.name }
      });
    },
    changeTestStatus: function (val) {
      this.is_start = val
    },
    //创建重现赛
    createReplay: function () {
      if (!this.isLogin) {
        this.$router.push({ name: 'login', params: { type: 'login' }, query: { redirect: this.$route.path } })
        return true
      }
      let params = {
        competition_id: this.competition_id,
        replay_type: 1
      }
      createReplay(params).then(response => {
        if (response.data) {
          let routeData = this.$router.resolve({
            name: 'replay-introduce',
            params: { competitionId: this.competition_id, times: response.data, replay_type: 1 }
          })
          window.open(routeData.href, '_blank')
        }
      })
    },
    //查看历史记录
    viewHistory: function () {
      this.dialogTableVisible = true;
    },
    //回顾重现赛
    viewReplay: function (times) {
      let routeData = this.$router.resolve({
        name: 'replay-introduce',
        params: { competitionId: this.competition_id, times: times }
      })
      window.open(routeData.href, '_blank')
    },
  },
  filters: {
    timestampToTime: function (val) {
      return Common.timestampToTime(val);
    },
    testTime: function (val) {
      return Common.testTime(val);
    }
  }
};
</script>
<style scoped>
.slide-img {
  width: 100%;
  position: relative;
  background-image: url(../../assets/imgs/c-back.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.competition-info {
  width: 1000px;
  height: 300px;
  margin: auto;
  padding: 30px 50px;
  box-sizing: border-box;
  color: #ffffff;
  position: relative;
}
.competition-info .competition-desc h1 {
  font-size: 2rem;
  margin: 20px 0;
}
.competition-info .competition-desc h1 i {
  font-size: 20px;
  position: relative;
  top: -10px;
  right: -10px;
  cursor: pointer;
}
.competition-info .competition-desc p {
  line-height: 30px;
}
.competition-info /deep/ .el-breadcrumb__item span {
  color: #ffffff !important;
}
.competition-info .competition-setting {
  position: absolute;
  top: 30px;
  right: 0;
  font-size: 24px;
  cursor: pointer;
}
.fr {
  float: right;
}
.not-apply {
  width: 1000px;
  margin: 0 auto 15px auto;
}
.cancle-apply {
  margin: 10px 0;
  text-align: right;
}
.cancle-apply span {
  color: #33ccb0;
  cursor: pointer;
}
.count-time {
  text-align: center;
}
.count-time p {
  margin: 10px 0;
}
.count-time button {
  width: 430px;
  color: #ffffff;
}
.count-time button.apply-btn {
  background-color: #33ccb0;
}
.count-time button.apply-btn:active {
  border: 1px solid #33ccb0;
}
.count-time ul {
  margin: 20px 0;
}
.count-time ul .time-item {
  display: inline-block;
  width: 100px;
  height: 120px;
  border-radius: 3px;
  background: #409eff;
  margin-right: 10px;
}
.count-time ul .time-item:last-child {
  margin: 0;
}
.count-time ul .time-item span {
  display: block;
  color: #ffffff;
  font-weight: bold;
}
.count-time ul .time-item span:first-child {
  height: 80px;
  line-height: 80px;
  font-size: 2.2rem;
}
.count-time ul .time-item span:last-child {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
}
.applied {
  width: 1000px;
  margin: auto;
  position: relative;
}
.applied .replay-btn {
  display: inline-block;
}
.applied .down-time {
  position: absolute;
  top: 10px;
  right: 10px;
}
.applied .down-time .time-tag {
  display: inline-block;
  font-style: normal;
  background-color: #33ccb0;
  color: #ffffff;
  text-align: center;
  padding: 2px;
  border-radius: 3px;
  margin-right: 3px;
}
.is-active {
  border-bottom: 2px solid #409eff !important;
}
</style>